module.exports = __webpack_public_path__ + "img/1566797512.ac4adc0b.jpg";